import { Component, inject, model } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BranchesService } from '../services/branches.service';
import { AccessService } from '../../core/services/access.service';
import { BranchModel } from '../../shared/models/branch.model';
import { BranchesFormComponent } from "../branches-form/branches-form.component";

@Component({
  selector: 'app-branch-details',
  standalone: true,
  imports: [BranchesFormComponent],
  templateUrl: './branch-details.component.html',
  styleUrl: './branch-details.component.css'
})
export class BranchDetailsComponent {
  private route = inject(ActivatedRoute)
  private service = inject(BranchesService)

  protected access = inject(AccessService).access
  protected id!: string | null;

  protected value = model<BranchModel | undefined>(undefined)
  constructor() {}
  ngOnInit(): void {
    this.service.title.update((value) => 'Dealles del Anuncio')
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id');
      this.getBranch(params.get('id'));
    });
  }

  getBranch(branchId: string | null) {
    console.log('getContract', branchId)
    if (branchId === null) {
      this.value.update((value) => (value = undefined));
    } else {
      // this.userService.userDetailed(userId);
      this.service.get(branchId).subscribe(data => {
        this.value.update((value) => (value = data as BranchModel));
      });
    }
  }
}
